"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeSSTFeatureFlags = exports.SSTFeatureFlagsUpdateSchema = exports.DEFAULT_SST_FEATURE_FLAGS = exports.SSTFeatureFlagsSchema = void 0;
var zod_1 = require("zod");
exports.SSTFeatureFlagsSchema = zod_1.z.object({
    hideAdminCreatedRequests: zod_1.z.boolean().default(false),
});
exports.DEFAULT_SST_FEATURE_FLAGS = {
    hideAdminCreatedRequests: false,
};
exports.SSTFeatureFlagsUpdateSchema = exports.SSTFeatureFlagsSchema;
var mergeSSTFeatureFlags = function (flags) { return ({
    hideAdminCreatedRequests: typeof (flags === null || flags === void 0 ? void 0 : flags.hideAdminCreatedRequests) === 'boolean'
        ? flags.hideAdminCreatedRequests
        : exports.DEFAULT_SST_FEATURE_FLAGS.hideAdminCreatedRequests,
}); };
exports.mergeSSTFeatureFlags = mergeSSTFeatureFlags;
//# sourceMappingURL=sstFeatureFlags.js.map